import styles from "./CodeSent.module.css";
import { ReactComponent as KlashaBlackLogo } from "../../../assets/logo-black.svg";
import { ReactComponent as LockIcon } from "../../../assets/lock.svg";
import { Button } from "../Button";
import { SupportEmail } from "../SupportFooter";

export const CodeSent = ({
  onPaid,
  isLoading,
}: {
  onPaid: () => void;
  isLoading?: boolean;
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
        <div className={styles.main}>
          <p className={styles.text}>Payment authorisation needed</p>
          <p className={styles.subtext}>
          Please authorise payment on your mobile device.
          </p>
          <p className={styles.subtext}>Once you've completed the payment, simply click the button below.</p>
          <div className={styles.confirmation_btn}>
            <Button
              type="button"
              text="I have authorised this payment"
              buttonStyle="klasha-pink-light"
              onClick={onPaid}
              isButtonLoading={isLoading}
            />
          </div>
          <SupportEmail />
        </div>
        <div className={styles.securedText}>
          <LockIcon />
          <p>Secured by</p>
          <KlashaBlackLogo />
        </div>
      </div>
    </div>
  );
};
